import emit from '../../../common/events';
import store from '../../../store/store';
import { Catalog } from '../../../common/constants/catalog';
import { HE_LOWER } from '../../../common/utils/util';
import { SearchFacet, SearchFacetValue } from '../../search/interfaces/search.interface';
import { StoreState } from '../../../store/store.interface';
import { getSearchPageAnalytics } from '../../../common/utils/analytics-util';
import { getUserDataForUserAnalytics } from '../../user-profile/user-profile.selectors';
import { selectSearchPageType } from '../../search/store/search.selector';

export class CreateSearchAnalytics {
  static search({
    element,
    id,
    searchPageType,
    storeCategory,
    term,
  }: {
    element: Element;
    id: string;
    searchPageType: string;
    storeCategory?: string;
    term: string;
  }): void {
    const state: StoreState = store.getState() as StoreState;

    emit({
      element,
      name: 'search',
      detail: {
        id,
        term,
        businessUnit: HE_LOWER,
        redirect: false,
        isSearchRedirect: false,
        url: window.location.href,
        store: storeCategory,
        catalog: Catalog.he,
        user: getUserDataForUserAnalytics(state),
        searchPageType: searchPageType,
        area: 'main',
        subarea: 'body',
      },
    });
  }

  static searchResults({
    element,
    id,
    storeCategory,
    term,
    searchPageType,
    totalResults,
  }: {
    element: any;
    id: string;
    storeCategory?: string;
    searchPageType?: string;
    term: string;
    totalResults: number;
  }): void {
    const state: StoreState = store.getState() as StoreState;

    emit({
      element: element,
      name: 'search-results',
      detail: {
        id: id,
        term: term,
        redirect: false,
        isSearchRedirect: false,
        store: storeCategory,
        url: window.location.href,
        user: getUserDataForUserAnalytics(state),
        totalResults: totalResults,
        searchPageType: searchPageType,
        catalog: Catalog.he,
        searchText: getSearchPageAnalytics(term, totalResults),
      },
    });
  }

  static filterBy({
    appliedFilters,
    element,
    facet,
    id,
    searchFacetValue,
    storeCategory,
    viaPill,
  }: {
    appliedFilters: any;
    element: any;
    facet: SearchFacet;
    id: string;
    searchFacetValue: SearchFacetValue;
    storeCategory?: string;
    viaPill?: boolean;
  }): void {
    const state: StoreState = store.getState() as StoreState;
    let analyticLogName = searchFacetValue.selected ? 'filter-remove-facet' : 'filter-add-facet';
    if (viaPill) {
      analyticLogName = 'filter-remove-facet-pill';
    }

    emit({
      element: element,
      name: analyticLogName,
      detail: {
        id: id,
        store: storeCategory,
        user: getUserDataForUserAnalytics(state),
        searchPageType: selectSearchPageType(state),
        catalog: Catalog.he,
        group: facet.name,
        name: searchFacetValue.name,
        label: searchFacetValue.label,
        'Refinement Type': 'Filter By',
        appliedFilters,
      },
      dataLayer: true,
    });
  }

  static filterClearAll({
    element,
    id,
    name,
    storeCategory,
  }: {
    element: any;
    id: string;
    name: string;
    storeCategory?: string;
  }): void {
    const state: StoreState = store.getState() as StoreState;

    emit({
      element: element,
      name: name,
      detail: {
        id: id,
        store: storeCategory,
        user: getUserDataForUserAnalytics(state),
        searchPageType: selectSearchPageType(state),
        catalog: Catalog.he,
        'Refinement Type': 'Filter By',
      },
      dataLayer: true,
    });
  }

  static filterGroup({
    element,
    id,
    name,
    componentName,
    opened,
    storeCategory,
  }: {
    element: any;
    id: string;
    name: string;
    componentName: string;
    opened: boolean;
    storeCategory?: string;
  }): void {
    const state: StoreState = store.getState() as StoreState;

    emit({
      element: element,
      name: opened ? 'filter-group-open' : 'filter-group-close',
      detail: {
        id: id,
        store: storeCategory,
        user: getUserDataForUserAnalytics(state),
        searchPageType: selectSearchPageType(state),
        catalog: Catalog.he,
        name: name,
        comp: componentName
      },
      dataLayer: true,
    });
  }

  static goToPage({
    element,
    id,
    pageIndex,
    storeCategory,
  }: {
    element: any;
    id: string;
    pageIndex: number;
    storeCategory?: string;
  }): void {
    emit({
      element: element,
      name: 'go-to-page',
      detail: {
        id: id,
        paginationNumber: pageIndex + 1,
        store: storeCategory,
        catalog: Catalog.he,
        searchPageType: selectSearchPageType(store.getState() as StoreState),
      },
      dataLayer: true,
    });
  }
}
